/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcSettingType2Regular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M9 6.1a.9.9 0 0 1 .9.9v2.1h.6a.9.9 0 1 1 0 1.8h-.6V17a.9.9 0 1 1-1.8 0v-6.1h-.6a.9.9 0 1 1 0-1.8h.6V7a.9.9 0 0 1 .9-.9m3.6 7.9a.9.9 0 0 1 .9-.9h.6V7a.9.9 0 0 1 1.8 0v6.1h.6a.9.9 0 1 1 0 1.8h-.6V17a.9.9 0 1 1-1.8 0v-2.1h-.6a.9.9 0 0 1-.9-.9" />
      <path
        fillRule="evenodd"
        d="M2.1 5A2.9 2.9 0 0 1 5 2.1h14A2.9 2.9 0 0 1 21.9 5v14a2.9 2.9 0 0 1-2.9 2.9H5A2.9 2.9 0 0 1 2.1 19zM5 3.9A1.1 1.1 0 0 0 3.9 5v14A1.1 1.1 0 0 0 5 20.1h14a1.1 1.1 0 0 0 1.1-1.1V5A1.1 1.1 0 0 0 19 3.9z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcSettingType2Regular;
